import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { PaginatedResults } from './@types';
import AuthServices from './auth.api';
import { getAuthToken } from '../utils/getAuthToken';
class BusinessTagService {
  private api: AxiosInstance;

  constructor(baseURL: string) {
    this.api = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Add an interceptor to attach the token to each request
    this.api.interceptors.request.use((config) => {
      const token = getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
    // Add an interceptor which detect 401 status code
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          AuthServices.logout();
        }

        return Promise.reject(error);
      },
    );
  }

  public async getBusinessTags(
    queryParams?: Record<string, any>,
  ): Promise<PaginatedResults> {
    const response: AxiosResponse<PaginatedResults> = await this.api.get(
      '/business-tags',
      {
        params: queryParams,
      },
    );
    return response.data;
  }
}

const _businessService = new BusinessTagService(
  process.env.REACT_APP_SERVER_API_URL || 'http://localhost:3000/v1',
);

export default _businessService;
